<template>
    <input
        :id="id"
        type="tel"
        autocomplete="off"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    />
</template>

<script>
import IMask from 'imask';

export default {
    props: {
        id: {
            type: String,
        },
        value: {
            type: String,
        },
    },
    data() {
        return {
            innerValue: '',
            mask: null,
            maskOptions: {
                mask: '+0 (000) 000-00-00',
                startsWith: '',
                lazy: true,
                autofix: true,
                overwrite: false,
                dispatch: function (appended, dynamicMasked) {
                    let number = (dynamicMasked.value + appended).replace(
                        /\D/g,
                        ''
                    );

                    return dynamicMasked.compiledMasks.find(function (m) {
                        return number.indexOf(m.startsWith) === 0;
                    });
                },
            },
        };
    },
    methods: {
        initMask() {
            this.destroyMask();
            this.mask = IMask(this.$el, this.maskOptions);
            this.mask.on('accept', this.onAccept);
            this.mask.on('complete', this.onComplete);
        },
        destroyMask() {
            this.mask && this.mask.destroy();
        },
        onAccept() {
            let value = this.mask.unmaskedValue;
            if (!value) {
            } else if (value[0] === '8') {
                value = '7' + value.substring(1);
            } else if (value[0] !== '7') {
                value = '7' + value;
            }

            let needChangeCaretPos =
                this.mask.unmaskedValue.length != value.length;

            this.mask.unmaskedValue = value;

            needChangeCaretPos &&
            setTimeout(() => {
                this.setCaretPosition(this.mask.value.length);
            }, 16);
            this.$emit('input', this.mask.unmaskedValue);
        },
        onComplete() {
            this.$emit('input', this.mask.unmaskedValue);
        },
        setMaskValue() {
            this.mask.unmaskedValue = this.value;
        },
        setCaretPosition(caretPos) {
            if (this.$el != null) {
                this.$el.focus();
                this.$el.setSelectionRange(caretPos, caretPos);
            }
        },
    },
    mounted() {
        this.initMask();
        this.setMaskValue();
    },
    watch: {
        value() {
            this.setMaskValue();
        },
    },
};
</script>
